<template>
  <div class="p-6 bg-white rounded shadow mb-6 max-w-xl mx-auto">
    <h2 class="text-2xl font-bold mb-4">Edit Hero Section</h2>
    <form @submit.prevent="submitForm" class="space-y-4">
      <div>
        <label class="block font-medium mb-1">Title</label>
        <input v-model="form.title" class="w-full border rounded px-3 py-2" required />
      </div>
      <div>
        <label class="block font-medium mb-1">Subtitle</label>
        <input v-model="form.subtitle" class="w-full border rounded px-3 py-2" required />
      </div>
      <div>
        <label class="block font-medium mb-1">CTA Text</label>
        <input v-model="form.cta" class="w-full border rounded px-3 py-2" required />
      </div>
      <div>
        <label class="block font-medium mb-1">Background Images (comma separated filenames)</label>
        <input v-model="bgImagesInput" class="w-full border rounded px-3 py-2" placeholder="bg_img.jpeg,bg_img2.jpeg" required />
      </div>
      <button type="submit" class="px-6 py-2 bg-primary text-white rounded hover:bg-primary-dark">Save</button>
      <div v-if="successMessage" class="text-green-600 mt-2">{{ successMessage }}</div>
      <div v-if="errorMessage" class="text-red-600 mt-2">{{ errorMessage }}</div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const form = ref({ title: '', subtitle: '', cta: '', bg_images: [] })
const bgImagesInput = ref('')
const successMessage = ref('')
const errorMessage = ref('')

const fetchHero = async () => {
  try {
    const response = await fetch('/api/hero')
    const data = await response.json()
    if (response.ok) {
      form.value = {
        title: data.title || '',
        subtitle: data.subtitle || '',
        cta: data.cta || '',
        bg_images: Array.isArray(data.bg_images) ? data.bg_images : []
      }
      bgImagesInput.value = form.value.bg_images.join(',')
    }
  } catch (err) {
    errorMessage.value = 'Failed to fetch hero data.'
  }
}

const submitForm = async () => {
  successMessage.value = ''
  errorMessage.value = ''
  form.value.bg_images = bgImagesInput.value.split(',').map(s => s.trim()).filter(Boolean)
  try {
    const response = await fetch('/api/hero', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form.value)
    })
    const data = await response.json()
    if (response.ok) {
      successMessage.value = 'Hero section updated successfully!'
    } else {
      errorMessage.value = data.error || 'Failed to update hero section.'
    }
  } catch (err) {
    errorMessage.value = 'Failed to update hero section.'
  }
}

onMounted(fetchHero)
</script> 